import { useCallback } from "react";
import { useMainContext } from "reducer";
import {
  IGlobalAlertDialog,
  IReducerActions,
  IReducerState,
  ISnackbarType,
  ReducerActionType,
} from "utils/interface";

export const useSnackbar = () => {
  // get reducer from context
  const { state, dispatch }: { state: IReducerState; dispatch: React.Dispatch<IReducerActions> } =
    useMainContext();

  const displaySnackbar = useCallback(
    (snackbarType: ISnackbarType, message: string) => {
      dispatch({
        type: ReducerActionType.showSnackbar,
        payload: {
          ...state,
          snackbar: {
            text: message,
            type: snackbarType,
            handleClose: () => {
              dispatch({
                type: ReducerActionType.hideSnackbar,
              });
            },
          },
        },
      });
    },
    [dispatch],
  );

  return { displaySnackbar };
};

export const useGlobalAlertDialog = () => {
  // get reducer from context
  const { state, dispatch }: { state: IReducerState; dispatch: React.Dispatch<IReducerActions> } =
    useMainContext();

  const displayGlobalAlertDialog = useCallback(
    (props: Omit<IGlobalAlertDialog, "isOpen">) => {
      dispatch({
        type: ReducerActionType.showGlobalAlertDialog,
        payload: {
          ...state,
          globalAlertDialog: {
            ...props,
            handleCancel: () => {
              if (props.handleCancel) props.handleCancel();
              dispatch({
                type: ReducerActionType.hideGlobalAlertDialog,
              });
            },
            handleConfirm: () => {
              if (props.handleConfirm) props.handleConfirm();
              dispatch({
                type: ReducerActionType.hideGlobalAlertDialog,
              });
            },
          },
        },
      });
    },
    [dispatch],
  );

  return { displayGlobalAlertDialog };
};
